import { useContext, useMemo, useEffect } from "react"
import PropTypes from "prop-types"
import ListItemDropDown from "components/list-item-dropdown"
import { CONTENT_SET_CONTEXT } from "./context"
import { useAnalytics } from "connected-components/analytics"
import { FACTORS_VIEW_EVENTS } from "../../analytics/events"

export default function ContentSetHeader({ contentSets, view: contentSetId }) {
  const { selectedCategory, setSelectedCategory } = useContext(CONTENT_SET_CONTEXT)
  const analytics = useAnalytics()

  const categoryOptions = useMemo(() => {
    const contentSet = contentSets.find(({ id }) => id === contentSetId)
    const defaultCategory = { id: "all", primaryText: "All" }
    if (!contentSet) {
      return [defaultCategory]
    }
    return [defaultCategory, ...contentSet.categories.map(({ id, name }) => ({ id, primaryText: name }))]
  }, [contentSets, contentSetId])

  useEffect(() => {
    if (categoryOptions.length > 0 && !categoryOptions.some(({ id }) => id === selectedCategory)) {
      setSelectedCategory(categoryOptions[0].id)
    }
  }, [categoryOptions, selectedCategory, setSelectedCategory])

  const handleCategoryChange = (category) => {
    analytics.track(FACTORS_VIEW_EVENTS.CATEGORY_SELECTED, { category })
    setSelectedCategory(category)
  }

  return <>
    <ListItemDropDown
      label="Category"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={categoryOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

ContentSetHeader.propTypes = {
  contentSets: PropTypes.array.isRequired,
  view: PropTypes.string.isRequired,
}
